<template>
  <div class="main-content">
    <div ref="signWrap" class="mycanvas">
      <canvas
        ref="canvas"
        class="canvasBg"
        :style="{
          backgroundColor: options.bgcolor ? options.bgcolor : '#fff'
        }"
      ></canvas>
    </div>
    <div class="flexbox button-line">
      <div class="flexbox">
        <div class="button-style cancel-button" @click="goBack">关闭</div>
        <div class="button-style clear-button" @click="clearArea">清除</div>
      </div>
      <div class="button-style save-button" @click="saveSign">保存</div>
    </div>
  </div>
</template>
<script>
import { base64ToBlob, compressImg } from '@/utils'
export default {
  data() {
    return {
      options: {
        bgcolor: ''
      },
      canvas: null,
      signWrap: null,
      image: '',
      mousePressed: false,
      ctx: '',
      lastX: 0,
      lastY: 0
    }
  },
  created() {},
  mounted() {
    this.canvas = this.$refs.canvas
    this.signWrap = this.$refs.signWrap
    this.image = ''
    this.mousePressed = false
    this.ctx = this.canvas.getContext('2d')
    this.canvas.width = this.signWrap.clientWidth
    this.canvas.height = this.signWrap.clientHeight
    this.initCanvas()
  },
  methods: {
    saveSign() {
      if (this.isCanvasBlank(this.canvas)) {
        console.log('请在签名区域签名后再次确认')
        return false
      } else {
        this.toWhite(this.canvas.width, this.canvas.height)
        const image = this.canvas.toDataURL('image/png') // 得到生成后的签名base64位  url 地址 image/jpeg ; image/png (清晰)
        compressImg(image, 0.9, 1, '仅供友邻认证', res => {
          const base64 = res.split(',')[1]
          base64ToBlob({ b64data: base64, contentType: 'image/png' }).then(res => {
            this.upSing(res)
          })
        })
      }
    },
    upSing(src) {
      this.$store
        .dispatch('goods/vip/imageTokenH5', {})
        .then(data => {
          this.$store.dispatch('goods/vip/uploadAliyun', { data, src }).then(res => {
            console.log('签名src:', res)
            this.$store.commit('goods/vip/saveCommitmentDetails', { signUrl: res })
            this.goBack()
          })
        })
        .catch(err => {
          console.log('获取pocily err', err)
          this.$toast({
            message: '我开小差了，重新传一张吧'
          })
        })
    },
    goBack() {
      this.$router.go(-1)
    },
    toWhite(w, h) {
      const imageData = this.ctx.getImageData(0, 0, w, h)
      for (let i = 0; i < imageData.data.length; i += 4) {
        // 当该像素是透明的，则设置成白色
        if (imageData.data[i + 3] === 0) {
          imageData.data[i] = 255
          imageData.data[i + 1] = 255
          imageData.data[i + 2] = 255
          imageData.data[i + 3] = 255
        }
      }
      this.ctx.putImageData(imageData, 0, 0)
    },
    initCanvas() {
      const _this = this
      // 触摸屏
      this.canvas.addEventListener(
        'touchstart',
        function (event) {
          if (event.targetTouches.length === 1) {
            event.preventDefault() // 阻止浏览器默认事件，重要
            const touch = event.targetTouches[0]
            _this.mousePressed = true
            _this.Draw(touch.pageX - this.offsetLeft, touch.pageY - this.offsetTop, false)
          }
        },
        false
      )
      this.canvas.addEventListener(
        'touchmove',
        function (event) {
          if (event.targetTouches.length === 1) {
            event.preventDefault() // 阻止浏览器默认事件，重要
            const touch = event.targetTouches[0]
            if (_this.mousePressed) {
              _this.Draw(touch.pageX - this.offsetLeft, touch.pageY - this.offsetTop, true)
            }
          }
        },
        false
      )
      this.canvas.addEventListener(
        'touchend',
        function (event) {
          if (event.targetTouches.length === 1) {
            event.preventDefault() // 阻止浏览器默认事件，防止手写的时候拖动屏幕，重要
            _this.mousePressed = false
          }
        },
        false
      )
      // 鼠标
      this.canvas.onmousedown = function (event) {
        _this.mousePressed = true
        _this.Draw(event.pageX - this.offsetLeft, event.pageY - this.offsetTop, false)
      }
      this.canvas.onmousemove = function (event) {
        if (_this.mousePressed) {
          _this.Draw(event.pageX - this.offsetLeft, event.pageY - this.offsetTop, true)
        }
      }
      this.canvas.onmouseup = function (event) {
        _this.mousePressed = false
      }
    },
    clearArea() {
      this.ctx.setTransform(1, 0, 0, 1, 0, 0)
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height)
    },
    isCanvasBlank(canvas) {
      const blank = document.createElement('canvas') // 系统获取一个空canvas对象
      blank.width = canvas.width
      blank.height = canvas.height
      return canvas.toDataURL() === blank.toDataURL() // 比较值相等则为空
    },
    Draw(x, y, isDown) {
      if (isDown) {
        this.ctx.beginPath()
        this.ctx.strokeStyle = '#000' // 颜色
        this.ctx.lineWidth = 3 // 线宽
        this.ctx.lineJoin = 'round'
        this.ctx.lineMax = 10 // 设置画笔最大线宽
        this.ctx.lineMin = 3 // 设置画笔最小线宽
        this.ctx.linePressure = 1.2 // 设置画笔笔触压力
        this.ctx.smoothness = 30 // 设置画笔笔触大小变化的平滑度
        this.ctx.moveTo(this.lastX, this.lastY)
        this.ctx.lineTo(x, y)
        this.ctx.closePath()
        this.ctx.stroke()
      }
      this.lastX = x
      this.lastY = y
    }
  }
}
</script>
<style lang="scss" scoped>
.main-content {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #f8f9fa;
  padding-top: 1rem;
}
.mycanvas {
  width: 94%;
  height: 5rem;
  margin: 0 auto 0;
  border: 1px dashed #00b25a;
  background-color: #fff;
  border-radius: 0.1rem;
  canvas {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.button-line {
  padding: 0 0.32rem;
  margin-top: 0.3rem;
  justify-content: space-between;
}
.button-style {
  color: #00b25a;
  width: 1.2rem;
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  border-radius: 0.1rem;
  margin-left: 0.2rem;
}
.save-button {
  background-color: transparent;
}
.clear-button {
  background-color: transparent;
}
.cancel-button {
  background-color: transparent;
}
</style>
